export enum UserValidationEnum {
    Data = 'Dados',
    Email = 'E-mail',
    Whatsapp = 'Whatsapp',
}

